// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__Pvi_o","description":"styles_description__WjZfK","skeleton-animation":"styles_skeleton-animation__8OVCf","container":"styles_container__cJ6gU"};